import classNames from 'classnames';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MaterialSidebar from './sidebar/MaterialSidebar.ianua';
import PageNavigation from './sidebar/PageNavigation';

type PageProps = PropsWithChildren;

export default function MaterialPage({ children }: PageProps) {
  const { nodeId, selectedModuleSlug } = useParams();
  const [overview, setOverviewMode] = useState(nodeId ? false : true);
  const [animateSidebar, setAnimateSidebar] = useState(overview);

  const includeSidebar = !!selectedModuleSlug;

  useEffect(() => {
    if (!overview && animateSidebar) {
      setTimeout(() => setAnimateSidebar(overview), 240);

      return;
    }

    if (overview !== animateSidebar) {
      setAnimateSidebar(overview);
    }
  }, [overview, animateSidebar]);

  useEffect(() => {
    setOverviewMode(nodeId ? false : true);
  }, [nodeId]);

  return (
    <div
      className={classNames('page', 'material-page', {
        'material-page-with-sidebar': includeSidebar,
        'sidebar--expanded': includeSidebar && animateSidebar,
      })}
    >
      <PageNavigation includeSideNavigation />
      <div className="main-layout">
        {includeSidebar && (
          <div className="sidebar-layout">
            <MaterialSidebar overview={overview} setOverviewMode={setOverviewMode} />
          </div>
        )}
        <div className="content-layout">
          <main>
            <div className="margin-wrapper">{children}</div>
          </main>
        </div>
      </div>
    </div>
  );
}
